import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AccessManagementPermissionAPIReturnFormats,
  AccessManagementPermissionMap,
  AccessManagementPermissionTreeNode,
} from '@cdw-ae/common-data';
import { Observable } from 'rxjs';
import { ApiUrlBuilderService } from '../../../../../../common/services/api-url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsDataService {
  constructor(
    private httpClient: HttpClient,
    private readonly urlBuilder: ApiUrlBuilderService
  ) {}

  public getPermissions(
    returnFormat?: AccessManagementPermissionAPIReturnFormats
  ): Observable<
    AccessManagementPermissionTreeNode[] | AccessManagementPermissionMap
  > {
    const url = this.urlBuilder.backendApi('permissions', 'getPermissions');
    return this.httpClient
      .post<
        AccessManagementPermissionTreeNode[] | AccessManagementPermissionMap
      >(url, {
        format: returnFormat,
      })
      .pipe();
  }
}
